module.exports = __webpack_public_path__ + "img/20.d8d7134d.png";